// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ka3By","title":"styles_title__2fMNM"};